import type { AnimationSource } from '../characters';

// Shared bone masks for humanoid rigs (Mixamo-compatible)
export const UPPER_BODY_MASK: readonly string[] = [
  'mixamorig:Spine',
  'mixamorig:Spine1',
  'mixamorig:Spine2',
  'mixamorig:Neck',
  'mixamorig:Head',
  'mixamorig:LeftShoulder',
  'mixamorig:LeftArm',
  'mixamorig:LeftForeArm',
  'mixamorig:LeftHand',
  'mixamorig:RightShoulder',
  'mixamorig:RightArm',
  'mixamorig:RightForeArm',
  'mixamorig:RightHand'
];

export const FULL_BODY_MASK: readonly string[] = [
  'mixamorig:Hips'
];

// Movement presets (world units per second)
export const WALK_SPEED = 2.5;
export const RUN_SPEED = 5.0;

// Physics presets
export const DEFAULT_JUMP_HEIGHT = 1.5;
export const DEFAULT_GRAVITY = 9.81;

// Utility helpers for reuse when building animation sources
export const DEFAULT_ATTACK_PHASES: AnimationSource['phases'] = {
  windup: { start: 0.0, end: 0.3 },
  active: { start: 0.3, end: 0.6 },
  recovery: { start: 0.6, end: 1.0 }
};